



























import { Component, Vue } from "vue-property-decorator";
import { deleteEvent } from "@/services/powerPlans/powerPlanEventService";

@Component
export default class PowerPlanDeleteModal extends Vue {
    eventToBeDeleted: string = "";
    eventName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(eventId: string, name: string) {
        this.eventToBeDeleted = eventId;
        this.eventName = name;
        this.$bvModal.show("modal-deleteEvent");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deleteEvent");
        this.eventName = "";
        this.eventToBeDeleted = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteEvent(this.eventToBeDeleted).then(() => {
            this.$emit("reload");
            this.eventName = "";
            this.eventToBeDeleted = "";
            this.$bvModal.hide("modal-deleteEvent");
        });
    }
}
